<template>
  <v-container grid-list-md pt-0 class="busca">
    <v-layout row wrap>
      <v-flex xs12>
        <header>
          <input
            type="text"
            class="inputSearch text-center mt-4 mb-4"
            :placeholder="$t('title.search')"
            v-model="inputSearch"
            ref="search"
            autofocus
          />
          <hr />
        </header>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <transition name="fade">
        <v-flex xs12 mt-4 mb-4 v-if="loaded == true && issues.length > 0">
          <h1 class="headline text-center">
            <b>{{ $t('text.Result') }}</b>
            <div class="body-1" v-if="issues.length === 1">({{ $t('text.OneIssueFound') }})</div>
            <div
              class="body-1"
              v-if="issues.length > 1"
            >({{ issues.length }} {{ $t('text.IssuesFound') }})</div>
          </h1>
        </v-flex>

        <v-flex xs12 mt-4 mb-4 v-if="loaded == true && issues.length == 0">
          <h1 class="headline text-center">
            <b>{{ $t('text.NoIssuesFound') }}</b>
            <br />
            <div class="body-1">
              <div v-if="inputSearch.length === 0"></div>
              <div v-else-if="inputSearch.length < 3">{{ $t('text.TypeAtLeast3Characters') }}</div>
              <div v-else>{{ $t('text.TryAnotherKeyword') }}</div>
            </div>
          </h1>
        </v-flex>
      </transition>

      <v-layout row wrap class="flex xs12 relative wrapper-loading">
        <loading v-if="loading"></loading>
        <card-issue
          v-for="item in issues"
          :key="`issue-${item.id}`"
          :id="item.id"
          :issue="item"
          :isFree="item.isFree"
          :img="item.coverThumbnail"
          :title="item.title.name"
          :subtitle="$t('text.Volume') + ' ' + item.volume"
        ></card-issue>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import loading from '@/components/Loading';
import cardIssue from '@/components/cardIssue';

export default {
  name: 'busca',
  components: {
    loading,
    'card-issue': cardIssue
  },
  metaInfo() {
    return {
      title: 'Super Comics - ' + this.$t(this.$route.meta.title)
    };
  },
  data() {
    return {
      loaded: false,
      loading: false,
      inputSearch: '',
      issues: []
    };
  },
  mounted() {
    bus.$emit('loading', false);
    this.$refs.search.focus();

    if (this.$route.params.term !== undefined) {
      this.getIssuesFromSearch(this.$route.params.term);
      this.inputSearch = this.$route.params.term;
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    inputSearch: function(val, oldVal) {
      this.getIssuesFromSearch(this.inputSearch);
    }
  },
  methods: {
    getIssuesFromSearch(term) {
      this.issues = [];
      this.loading = true;
      const isChild = localStorage.getItem('password') === null ? false : true;

      if (term.length === 0) {
        this.loaded = true;
        this.loading = false;
        return;
      } else if (term.length < 3) {
        this.loaded = true;
        this.loading = false;
        return;
      }

      this.$router.push({
        name: 'Busca',
        params: {
          term: term
        }
      });

      bus.$emit('loading', true);

      if (isChild){
        axios
        .get('/api/issues/child/search?q=' + term)
        .then(response => {
          this.issues = response.data.results;
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
          console.error(e)
        });

      } else {
        axios
        .get('/api/issues/search?q=' + term)
        .then(response => {
          this.issues = response.data.results;
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
          console.error(e)
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/_variables';

.busca {
  .headline {
    .body-1 {
      line-height: 20px;
    }
  }

  .inputSearch {
    width: 100%;
    outline: none;
    color: $primary;
    font-size: 42px;

    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #ddd;
      opacity: 1;
      /* Firefox */
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #ddd;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #ddd;
    }
  }

  @media only screen and (max-width: 959px) {
    header {
      margin-top: -30px;
    }

    .inputSearch {
      margin-bottom: 10px !important;
    }
  }

  @media only screen and (max-width: 480px) {
    header {
      margin-top: 0px;

      .inputSearch {
        font-size: 25px;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
      }
    }
  }
}
</style>
